export const getMappedColumn = (column) => {
    switch (column) {
        case 'FirmName':
            return 'firmName';
        case 'Username':
            return 'username';
        case 'AccountId':
            return 'acctId';
        case 'RequesterUsername':
            return 'requesterUsername';
        case 'AlertCode':
            return 'code';
        default:
            return column;
    }
};